<template>
    <div class="bg-white dark:bg-gray-800 rounded-lg shadow-md overflow-hidden">
      <div v-if="title || $slots.header" class="px-4 py-3 border-b dark:border-gray-700">
        <slot name="header">
          <h3 class="text-lg font-medium text-gray-700 dark:text-gray-200">{{ title }}</h3>
        </slot>
      </div>
      
      <div class="p-4">
        <slot></slot>
      </div>
      
      <div v-if="$slots.footer" class="px-4 py-3 border-t dark:border-gray-700 bg-gray-50 dark:bg-gray-900">
        <slot name="footer"></slot>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'Card',
    props: {
      title: {
        type: String,
        default: ''
      }
    }
  };
  </script>